module.exports = __webpack_public_path__ + "img/step2.0d617a30.png";